'use client';

import { useTargetType } from '../../../store/projectStore';
import { TARGET_TYPE } from '../../../utils/target-scope.utils';
import { PentesterDashboard } from '../../dashboard/PentesterDashboard';
import { ExternalNetworkOverviewTab } from './ExternalNetworkOverviewTab';
import { InternalNetworkOverviewTab } from './InternalNetworkOverviewTab';
import { AiApplicationOverviewTab } from './AiApplicationOverviewTab';

export function TargetOverviewContent() {
  const targetType = useTargetType();

  switch (targetType) {
    case TARGET_TYPE.EXTERNAL_NETWORK:
      return <ExternalNetworkOverviewTab />;
    case TARGET_TYPE.INTERNAL_NETWORK:
      return <InternalNetworkOverviewTab />;
    case TARGET_TYPE.AI_APPLICATION:
      return <AiApplicationOverviewTab />;
    case TARGET_TYPE.WEB_APPLICATION:
    default:
      return <PentesterDashboard />;
  }
}
